import * as types from '../constants/action-types';

export const toggleBanner = (bannerId) => {
  return {
    type: types.TOGGLE_BANNER,
    bannerId
  };
};

export const clearBanner = () => {
  return {
    type: types.CLEAR_BANNER,
    bannerId: ''
  };
};
